module.exports = __webpack_public_path__ + "img/Celebration.da3774b0.png";